import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const DELEGATION_MANAGEMENT_URLS: generalConst = {
  BASE_URL: ROUTES.DELEGATES,
  ADD_DELEGATION: `${ROUTES.DELEGATES}/AddDelegation`,
  USER_CHOICE: `${ROUTES.DELEGATES}/UserChoice`,
};

export interface IDelegationManagementProps {
  resetDelegationState: () => {};
}

export const EMPLOYEE: string = "Employee";
export const CONSULTANT: string = "Consultant";
